import * as types from './types.js';

export const updateUnites = pas => {
    return {
        type: types.UPDATE_UNITES,
        payload: { pas },
    };
};

export const updateFractions = pas => {
    return {
        type: types.UPDATE_FRACTIONS,
        payload: { pas },
    };
};

export const toggleVisibilityNumbers = () => {
    return {
        type: types.TOGGLE_VISIBILITY_NUMBERS,
    };
};
